import { emitEvent } from '@tyler-components-web/core';
import { toggleAttribute } from '../utils';
var BaseAdapter = /** @class */ (function () {
    function BaseAdapter(_component) {
        this._component = _component;
    }
    BaseAdapter.prototype.getHostAttribute = function (name) {
        return this._component.getAttribute(name);
    };
    BaseAdapter.prototype.setHostAttribute = function (name, value) {
        if (value === void 0) { value = ''; }
        this._component.setAttribute(name, value);
    };
    BaseAdapter.prototype.removeHostAttribute = function (name) {
        this._component.removeAttribute(name);
    };
    BaseAdapter.prototype.toggleHostAttribute = function (name, hasAttribute, value) {
        toggleAttribute(this._component, hasAttribute, name, value);
    };
    BaseAdapter.prototype.emitHostEvent = function (type, data, bubble, cancelable) {
        if (data === void 0) { data = null; }
        if (bubble === void 0) { bubble = true; }
        return emitEvent(this._component, type, data, bubble, cancelable);
    };
    BaseAdapter.prototype.addHostListener = function (event, callback, options) {
        this._component.addEventListener(event, callback, options);
    };
    BaseAdapter.prototype.removeHostListener = function (event, callback) {
        this._component.removeEventListener(event, callback);
    };
    BaseAdapter.prototype.addWindowListener = function (event, callback, options) {
        window.addEventListener(event, callback, options);
    };
    BaseAdapter.prototype.removeWindowListener = function (event, callback, options) {
        window.removeEventListener(event, callback, options);
    };
    BaseAdapter.prototype.addDocumentListener = function (event, callback, options) {
        document.addEventListener(event, callback, options);
    };
    BaseAdapter.prototype.removeDocumentListener = function (event, callback, options) {
        document.removeEventListener(event, callback, options);
    };
    BaseAdapter.prototype.getScreenWidth = function () {
        return window.innerWidth;
    };
    BaseAdapter.prototype.setBodyAttribute = function (name, value) {
        document.body.setAttribute(name, value);
    };
    BaseAdapter.prototype.removeBodyAttribute = function (name) {
        document.body.removeAttribute(name);
    };
    return BaseAdapter;
}());
export { BaseAdapter };
